import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h1", null, "Archivio", -1)
const _hoisted_2 = { class: "album py-5 bg-light" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_6 = {
  key: 1,
  class: "d-flex justify-content-center"
}
const _hoisted_7 = {
  key: 2,
  class: "row row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 g-3"
}
const _hoisted_8 = { class: "card shadow-sm" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "card-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_NavBar),
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _hoisted_5
            ]))
          : (_ctx.error)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode("h5", null, _toDisplayString(_ctx.error), 1)
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_7, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (o) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "col",
                    key: o
                  }, [
                    _createVNode(_component_router_link, {
                      to: '/manga/'+o.id,
                      style: {"text-decoration":"none","color":"black"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode("div", _hoisted_8, [
                          _createVNode("img", {
                            class: "bd-placeholder-img card-img-top",
                            style: {"object-fit":"cover","aspect-ratio":"12/17"},
                            src: o.cover,
                            role: "img"
                          }, null, 8, ["src"]),
                          _createVNode("div", _hoisted_9, [
                            _createVNode("h5", _hoisted_10, _toDisplayString(o.title), 1)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ]))
      ])
    ])
  ]))
}